import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IdpProviders from './IdpProviders';
import { stopReloadPage } from '../../../actions/reload-page-manager';

const mapStateToProps = (state) => ({
  globalSettings: state.globalSettingsManager.globalSettings,
  selectedNode: state.selectedNodeManager.node,
  reloadPage: state.reloadPageManager.reloadPage,
  roles: state.userManager.user.roles,
  mainColor: state.userManager.mainColor,
  rootNode: state.userManager.user.accountInfo
    ? state.userManager.user.accountInfo.nodeData
    : { nodeId: 1, nodeName: 'Base' },
});

const mapDispatchToProps = (dispatch) => ({
  stopReloadPage: () => dispatch(stopReloadPage()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IdpProviders)
);
